// Vue compiles the server rendered markup of the page and of modal dialogs as a template. The views never interpolate
// with `{{ }}` themselves, so any text containing it was entered by users (names, comments, descriptions, ...) and
// would be evaluated as an expression. Such texts are excluded from compiling by `v-pre`, to be shown as they are.
const INTERPOLATION_START = '{{'

// The content of these elements is text only, so it can't be wrapped and the element itself is excluded
const TEXT_ONLY_ELEMENTS = ['TEXTAREA', 'TITLE']

export function protectFromInterpolation(root) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT)
  const texts = []
  while (walker.nextNode()) {
    if (walker.currentNode.nodeValue.includes(INTERPOLATION_START)) {
      texts.push(walker.currentNode)
    }
  }

  for (const text of texts) {
    const parent = text.parentElement
    if (TEXT_ONLY_ELEMENTS.includes(parent.tagName)) {
      parent.setAttribute('v-pre', '')
      continue
    }

    const wrapper = document.createElement('span')
    wrapper.setAttribute('v-pre', '')
    text.replaceWith(wrapper)
    wrapper.appendChild(text)
  }
}
